import { ScheduledAssessmentStatus } from '@leads/shared/models/domain/scheduled-assessment.domain';

export interface ICalendarEventColour {
	primary: CalendarColours;
	secondary: CalendarColours;
	secondaryText?: CalendarColours;
}

export enum CalendarColours {
	BLACK = '#000000',
	WHITE = '#FFFFFF',
	GREY_LIGHT = '#D9D9D9',
	GREY_DARK = '#8C8C8C',
	BLUE_LIGHT = '#E6F4FF',
	RED = '#FF4D4F',
	ORANGE = '#FAAD14',
	TEAL = '#36CFC9',
	YELLOW = '#FFEC3D',
	GREEN_DARK = '#389E0D',

	// Google Colours
	DEFAULT_BLUE = '#039BE5',
	LAVANDER = '#7986CB',
	GRAPE = '#8E24AA',
	TANGERINE = '#E67C73',
	BANANA = '#F6BF26',
	BASIL = '#33B679',
	SAGE = '#0B8043',
	PEACOCK = '#039BE5',
	CYAN = '#4285F4',
	GRAPHITE = '#616161',
	FLAMINGO = '#E37400',
	TOMATO = '#D50000',

	BANANA_LIGHT = '#FCE89C',
	SAGE_LIGHT = '#70C08B',
}

export class CalendarEventColours {
	private static statusColours: Record<ScheduledAssessmentStatus, ICalendarEventColour> = {
		[ScheduledAssessmentStatus.REQUESTED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.GREY_LIGHT,
			secondaryText: CalendarColours.BLACK,
		},
		[ScheduledAssessmentStatus.SCHEDULED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.DEFAULT_BLUE,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.DECLINED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.TOMATO,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.CANCELLED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.TOMATO,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.AWAITING_QUOTE]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.TANGERINE,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.AWAITING_INVOICE]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.TANGERINE,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.INVOICED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.BANANA,
			secondaryText: CalendarColours.WHITE,
		},
		[ScheduledAssessmentStatus.PARTIALLY_PAID]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.BANANA_LIGHT,
			secondaryText: CalendarColours.BLACK,
		},
		[ScheduledAssessmentStatus.WORK_COMPLETED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.SAGE_LIGHT,
			secondaryText: CalendarColours.BLACK,
		},
		[ScheduledAssessmentStatus.COMPLETED]: {
			primary: CalendarColours.WHITE,
			secondary: CalendarColours.SAGE,
			secondaryText: CalendarColours.WHITE,
		},
	};

	static scheduledAssessment(status: ScheduledAssessmentStatus): ICalendarEventColour {
		return this.statusColours[status] ?? this.statusColours[ScheduledAssessmentStatus.SCHEDULED];
	}
}
